import React, { useEffect, useState } from "react";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import FileUpload from "../../../../components/FileUpload/FileUpload";
import useToastAlert from "@/hooks/useToastAlert";
import useApi from "@/hooks/useApi";
import { Severity } from "@velaro/velaro-component-lib";
import { UploadedFile } from "../../FileStorage/types";
import { LoadingSpinner } from "@velaro/velaro-component-lib";
import Panel from "@/components/Panel";
import UploadedFileEditor from "../../FileStorage/UploadedFileEditor";
import FilesEditor from "@/components/FileUpload/FilesEditor";

interface Props {
  allowDrop?: boolean;
}

export default function AIChatbotFileTrainingIndex(props: Props) {
  const [files, setFiles] = useState<UploadedFile[]>([]);
  const [newFiles, setNewFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState(true);
  const toast = useToastAlert();
  const api = useApi();

  async function save() {
    setLoading(true);
    const formData = new FormData();

    for (const file of newFiles) {
      formData.append("files", file);
    }
    formData.append("type", "AI");

    const result = await api.messaging.postFormData("uploadedFiles", formData);
    if (result.status !== 200) {
      setLoading(false);
      toast.displayToast(
        Severity.Error,
        "Error uploading files: " + (await result.text())
      );
      return;
    }

    setFiles([...files, ...(await result.json())]);
    setNewFiles([]);
    toast.displayToast(Severity.Success, "Files uploaded successfully");
    setLoading(false);
  }

  async function remove(file: UploadedFile) {
    await api.messaging.delete("uploadedFiles", { id: file.id });
    const clone = [...files];
    clone.splice(files.indexOf(file), 1);
    setFiles(clone);
  }

  useEffect(() => {
    async function fetchFiles() {
      const response = await api.messaging.get(`uploadedFiles/list/${"AI"}`);
      setFiles(await response.json());
      setLoading(false);
    }
    fetchFiles();
  }, [api.messaging]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {props.allowDrop && (
        <div className="mt-4">
          <FileUpload onAddFiles={setNewFiles} multiple>
            <div className="flex flex-row text-slate-500 text-xs">
              Supported files: PDF, TXT, DOC, DOCX. Images won&apos;t be
              scraped.
            </div>
            <div className="flex flex-row text-slate-500 text-xs">
              You can upload a maximum of 5 files at once, with each file not
              exceeding 20 MB.
            </div>
          </FileUpload>
          <FilesEditor files={newFiles} onUpdate={setNewFiles} />
        </div>
      )}
      <div>
        {props.allowDrop && (
          <div className="flex justify-end mt-4">
            <PrimaryBlueButton
              label="Upload"
              disabled={newFiles.length === 0}
              onClick={() => save()}
            />
          </div>
        )}
        {files.length > 0 && (
          <div className="mt-4">
            <Panel title={"Uploaded"}>
              <div className="p-4">
                <UploadedFileEditor files={files} onRemove={remove} />
              </div>
            </Panel>
          </div>
        )}
      </div>
    </>
  );
}
